import React,  { useEffect, useState } from "react"

//interfaces
import { IContentTile } from "thrive-components/interfaces/content/content";

//model
import { DesignModel } from "./Design.model";
import { SUACService } from "../../services/SignUpAppConfig.service";

//components
import { BasicButton, IconLibrary, ThriveIcon, MobileAppPreview, ThemeColourPicker, ReorderContentTilesModal, LoadingSpinner, ToastMessage, ActionFeedbackBanner, ActionFeedback } from "thrive-components";
import { useBeforeNavigateAway } from "thrive-components/hooks/useBeforeNavigateAway";

//hooks
import useNavigatorSetup from "../../utils/hooks/useNavigatorSetup";
import { useObservable } from "thrive-observable-react";
import useScrollToTop from "../../utils/hooks/useScrollToTop";

//styles
import './design.scss';



const Design = () => {
    const [DM] = useState(() => new DesignModel());
    const showModal = useObservable<boolean>(DM.showReorderContentTilesModal);
    const colour = useObservable<string>(SUACService.colour);
    const fontColour = useObservable<string>(SUACService.fontColour);
    const contentTiles = useObservable<IContentTile[]>(SUACService.contentTiles);
    const appName = useObservable<string>(SUACService.appName);
    const loading = useObservable<boolean>(DM.loading);
    const showBanner = useObservable<boolean>(DM.showErrorBanner);

    useEffect(() => {
        SUACService.setColour("203554")
    }, []);

    useNavigatorSetup();
    useBeforeNavigateAway(true);
    useScrollToTop();
    
    return (
        <div className="design-page page-container" style={{ "--brandColor": `#${colour}`, "--brandFontColor": fontColour } as React.CSSProperties}>
            <div className="design-container">
                {loading
                    ?   <LoadingSpinner size={10} />
                    :   <>
                            <h1 className="design-heading">
                                {DM.title}
                            </h1>

                            <h2 className="design-sub-heading">
                                {DM.subtitle}
                            </h2>
                            
                            <ThemeColourPicker
                                colour={colour} 
                                setColour={SUACService.setColour}
                            />

                            <BasicButton 
                                className={`reorder-button`} 
                                content={DM.reorderButton} 
                                ariaLabel={DM.reorderButton}     
                                onButtonClick={DM.onReorderTilesClick}
                            />

                            <BasicButton 
                                className={`design-button`} 
                                content={
                                    <>
                                    {DM.button}
                                    <ThriveIcon 
                                        iconName={IconLibrary.ARROW_LEFT}
                                        className="right-arrow"
                                        color="var(--thriveWhite)"
                                        sizeInPx="14"
                                    />
                                    </>
                                } 
                                ariaLabel={DM.button}     
                                onButtonClick={DM.onContinueClick}
                            />

                            <ReorderContentTilesModal 
                                showModal={showModal} 
                                onHideModal={DM.hideReorderContentTilesModal} 
                                setContentTileOrder={DM.onSaveContentOrderClick} 
                                contentTiles={contentTiles}
                            />
                        </>
                }
            </div>

            <MobileAppPreview
                appContent={contentTiles}
                appName={appName}
            />

            {showBanner &&
                <ActionFeedbackBanner 
                    feedbackType={ActionFeedback.ERROR} 
                    feedbackMessage={"Something went wrong"}
                />
            }
        </div>
    )
}

export default Design